import { createSlice } from "@reduxjs/toolkit";

const tasksSlice = createSlice({
  name: "tasks",
  initialState: {},
  reducers: {
    setTask: (state, action) => {
      return { ...state, [action.payload.id]: action.payload };
    },
    removeTask: (state, action) => {
      const newState = { ...state };
      delete newState[action.payload];

      return newState;
    },
  },
});

// Extract the action creators object and the reducer
const { actions, reducer } = tasksSlice;

// Extract and export each action creator by name
export const { setTask, removeTask } = actions;

// Export the reducer, either as a default or named export
export default reducer;
